//import axios from "axios";
import React, { useState } from "react";
//import { useSelector } from "react-redux";

function Checkout({ userInfo, setUserInfo }) {
  const [isGift, setIsGift] = useState(false);
  const updateUserInfo = (e) => {
    setUserInfo({
      ...userInfo,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <form>
        <label for="inputFirstName" className="fw-bold fs-6 mt-3 mb-2">
          Nombre*
        </label>
        <input
          name="firstName"
          onChange={updateUserInfo}
          type="text"
          className="form-control"
          placeholder="John"
          id="inputFirstName"
          value={userInfo.firstName}
          disabled
        />
        <label for="inputFirstName" className="fw-bold fs-6 mt-3 mb-2">
          Apellido*
        </label>
        <input
          name="lastName"
          onChange={updateUserInfo}
          type="text"
          className="form-control"
          placeholder="Doe"
          id="inputLastName"
          value={userInfo.lastName}
          disabled
        />
        <label for="inputEmail" className="fw-bold fs-6 mt-3 mb-2">
          Dirección de correo electrónico *
        </label>
        <input
          type="email"
          name="email"
          onChange={updateUserInfo}
          className="form-control"
          placeholder="example@mail.com"
          id="inputEmail"
          value={userInfo.email}
          disabled
          pattern="[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
        />

        <label for="inputaddress" className="fw-bold fs-6 mt-3 mb-2">
          Dirección de entrega (Ej: calle, número de puerta, apto, esquina)*
        </label>
        <input
          name="address"
          onChange={updateUserInfo}
          type="text"
          className="form-control"
          id="address"
          value={userInfo.address}
          disabled
        />

        <label for="inputphone" className="fw-bold fs-6 mt-3 mb-2">
          Teléfono
        </label>
        <input
          name="phone"
          onChange={updateUserInfo}
          type="number"
          className="form-control"
          id="inputphone"
          value={userInfo.phone}
          disabled
        />
        <div className="form-check my-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="flexCheckDefault"
            onChange={(e) => setIsGift(e.target.checked)}
          />
          <label className="form-check-label" for="flexCheckDefault">
            Esta orden es para regalo?
          </label>
        </div>
        {isGift ? (
          <>
            <label for="inputNameGift" className="fw-bold fs-6 mt-3 mb-2">
              Nombre y apellidos
            </label>
            <input
              name="nameGift"
              onChange={updateUserInfo}
              type="text"
              className="form-control"
              id="nameGift"
              value={userInfo.nameGift}
            />

            <label for="inputAddressGift" className="fw-bold fs-6 mt-3 mb-2">
              Dirección de entrega (Ej: calle, número de puerta, apto, esquina)
            </label>
            <input
              name="addressGift"
              onChange={updateUserInfo}
              type="text"
              className="form-control"
              id="addressGift"
              value={userInfo.addressGift}
            />
          </>
        ) : null}
      </form>
    </>
  );
}

export default Checkout;
